import {Component, OnDestroy, OnInit} from '@angular/core';
import {Card} from '../../core/entities/entities';
import {Router} from '@angular/router';
import {CardQuery, CardService} from '../../services/card.service';
import {NowComponentBase} from '../../shared/base/NowComponentBase';
import * as Rx from 'rxjs/Rx';
import {TypeaheadMatch} from 'ngx-bootstrap';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs/Observable';

@Component({
  templateUrl: './search-card.component.html',
  styleUrls: ['./search-card.component.css']
})
export class SearchCardComponent extends NowComponentBase implements OnInit, OnDestroy {
  card_search: CardQuery = {autocomplete_edition: '', autocomplete_card_name: '', autocomplete_language: this.defaultLanguageId};
  cards: Observable<Card[]>;
  card: Card;

  ngOnInit() {
    this.cards = Rx.Observable.create((observer: any) => {
      observer.next(this.card_search);
    }).switchMap(() => {
      return this._cardServ.search(this.card_search);
    });

    super.ngOnInit();
  }

  selectCard(event: TypeaheadMatch) {
    if (event && event.item) {
      this.card = event.item;
      this.card_search.autocomplete_card_name = this.card.name;
      this.card_search.autocomplete_edition = this.card.edition;
      this._cardServ.query = {card: this.card};
    }
  }

  eraseCard() {
    this.card_search.autocomplete_edition = '';
    this._cardServ.query = this.card_search;
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  constructor(private _cardServ: CardService, private _router: Router) {
    super();
  }

}



// WEBPACK FOOTER //
// ./src/app/home/search-card/search-card.component.ts